module.exports = "/_next/static/images/trustly-white-f9ea2ba4b97715658e13f5abda1d13b4.svg";